var _style, _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _linearGradient9, _path9, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWonderlicSelectLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "wonderlic_select_logo_svg__Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    viewBox: "154.08 91.48 890.82 92.02",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".wonderlic_select_logo_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#wonderlic_select_logo_svg__SVGID_1_)}.wonderlic_select_logo_svg__st9{fill:#2a2f3c}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.905,
    y1: 26.172,
    x2: 331.038,
    y2: 118.493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_svg__st0",
    d: "M316.4 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.2 13.2-11.8z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_svg__SVGID_00000150065514906057686850000006488401391693805994_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.032,
    y1: 44.97,
    x2: 314.165,
    y2: 137.291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.1 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.2 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_svg__SVGID_00000150065514906057686850000006488401391693805994_)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_svg__SVGID_00000103952655353814114630000016674498862700288150_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.285,
    y1: 82.565,
    x2: 280.418,
    y2: 174.886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.6 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.2 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_svg__SVGID_00000103952655353814114630000016674498862700288150_)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_svg__SVGID_00000114058967886156425110000016726940146507876507_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.412,
    y1: 101.363,
    x2: 263.544,
    y2: 193.684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.3 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.2 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_svg__SVGID_00000114058967886156425110000016726940146507876507_)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_svg__SVGID_00000140722887414757720470000005078657305503376819_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.588,
    y1: 65.426,
    x2: 294.226,
    y2: 160.057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.3 181.2c-5.1-3.9-6.1-11.2-2.3-16.4l32.8-44.9c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-32.8 44.9c-3.8 5.2-10.9 6.2-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_svg__SVGID_00000140722887414757720470000005078657305503376819_)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_svg__SVGID_00000168096786030573563660000001546791914085238157_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.018,
    y1: 75.338,
    x2: 286.564,
    y2: 168.963
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.1 159.2c-5.1-3.9-6.1-11.2-2.3-16.4l16.7-22.9c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-16.7 22.9c-3.8 5.2-10.9 6.2-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_svg__SVGID_00000168096786030573563660000001546791914085238157_)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_svg__SVGID_00000169532583623453099820000002289764518624154264_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.206,
    y1: 107.903,
    x2: 258.016,
    y2: 200.849
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.7 146.6c-5.1-3.9-6.1-11.2-2.3-16.4l7.5-10.3c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-7.5 10.3c-3.7 5.2-10.9 6.2-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_svg__SVGID_00000169532583623453099820000002289764518624154264_)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_svg__SVGID_00000023249709241217660270000000705678455647061435_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.148,
    y1: 81.594,
    x2: 281.28,
    y2: 173.914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.7 111.1c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.3 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_svg__SVGID_00000023249709241217660270000000705678455647061435_)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_svg__SVGID_00000105426630601623735220000011198167472640785583_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.273,
    y1: 113.316,
    x2: 252.955,
    y2: 207.065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.8 181.2c-5.1-3.9-6.1-11.2-2.3-16.4l18.5-25.4c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-18.5 25.4c-3.8 5.2-11 6.2-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_svg__SVGID_00000105426630601623735220000011198167472640785583_)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_svg__st9",
    d: "M344.8 118h6.4l12.2 34 13.5-37.3 13.5 37.3 12.2-34h6.4l-18.6 51.4-13.5-37.3-13.5 37.3-18.6-51.4zM437.1 116.5c13.3 0 24 10.8 24 25.5s-10.8 25.5-24 25.5c-13.3 0-24-10.8-24-25.5s10.7-25.5 24-25.5zm0 44.4c10 0 17.4-8.1 17.4-18.9 0-10.8-7.4-18.9-17.4-18.9-10 0-17.4 8.1-17.4 18.9 0 10.8 7.3 18.9 17.4 18.9zM471.5 118h6.6v8.1c2.3-5.2 7.4-8.9 14.5-8.9 10.4 0 16.8 7.3 16.8 18.1V166h-6.6v-29.2c0-8-4.5-13.1-11.8-13.1-7.5 0-12.8 5.4-12.8 13.5v28.7h-6.6V118zM542.3 116.5c8.9 0 13.8 4.5 16.1 8.6V99.6h6.6v66.5h-6.6v-7.2c-2.2 4.1-7.2 8.6-16.1 8.6-12.6 0-22.9-10.8-22.9-25.5s10.2-25.5 22.9-25.5zm0 44.4c9.7 0 16.9-8.1 16.9-18.9 0-10.8-7.2-18.9-16.9-18.9-9.3 0-16.2 8.1-16.2 18.9 0 10.8 6.9 18.9 16.2 18.9zM575.4 142.2c0-15.6 9.7-25.7 22.6-25.7 12.6 0 20.8 10.7 20.8 23.9 0 0 0 1.6-.1 3.1H582c.4 10.6 6.6 17.4 16.1 17.4 6.5 0 10.1-2.5 13.9-6.7l4.4 4.6c-5.7 6.7-11.7 8.5-18.3 8.5-13.5 0-22.8-9.7-22.8-24.7v-.4zm36.3-4.9c0-7.7-6.1-14.2-13.7-14.2-8.2 0-15.1 6.4-15.5 14.2h29.2zM628.9 118h6.6v8.1c2.2-5.2 7.1-8.9 13.9-8.9 1 0 2.2.1 2.8.2v7.6c-1.1-.3-2.6-.5-4.5-.5-7 0-12.2 5.4-12.2 13.5v28h-6.6v-48zM663.6 99.6h6.6v53.9c0 5.2 1.4 7.4 5.7 7.4 1.1 0 2.2-.1 3.2-.4v6.6c-1.1.3-2.2.4-3.2.4-4.8 0-12.3-1.1-12.3-13.5V99.6zM686.5 105.2c0-2.8 2.2-4.8 4.5-4.8s4.5 2 4.5 4.8-2.2 4.8-4.5 4.8-4.5-2.1-4.5-4.8zm1.2 12.8h6.6v48.1h-6.6V118zM728.8 116.5c6.8 0 12.7 2.5 17.1 7.3l-4 5c-3.4-3.7-8-5.6-13.1-5.6-10 0-17.4 8.1-17.4 18.9 0 10.8 7.4 18.9 17.4 18.9 5.1 0 9.7-1.9 13.1-5.6l4 5c-4.4 4.8-10.3 7.3-17.1 7.3-13.3 0-24-10.8-24-25.5 0-14.9 10.8-25.7 24-25.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_svg__st9",
    d: "M782.4 165.9c-3.5-1.5-6.3-3.7-8.4-6.5-2.1-2.8-3.1-6.2-3.2-10h13.6c.2 2.6 1.1 4.6 2.8 6.2 1.7 1.5 3.9 2.3 6.8 2.3 3 0 5.3-.7 7-2.1 1.7-1.4 2.5-3.3 2.5-5.6 0-1.9-.6-3.4-1.7-4.6-1.1-1.2-2.6-2.2-4.3-2.9-1.7-.7-4.1-1.5-7.1-2.3-4.1-1.2-7.4-2.4-10-3.6-2.6-1.2-4.8-3-6.6-5.3-1.8-2.4-2.8-5.6-2.8-9.5 0-3.7.9-7 2.8-9.8 1.9-2.8 4.5-4.9 7.9-6.4 3.4-1.5 7.2-2.2 11.6-2.2 6.5 0 11.8 1.6 15.9 4.8 4.1 3.2 6.3 7.6 6.7 13.3H802c-.1-2.2-1-4-2.8-5.4-1.7-1.4-4-2.1-6.8-2.1-2.5 0-4.4.6-5.9 1.9-1.5 1.3-2.2 3.1-2.2 5.5 0 1.7.6 3.1 1.7 4.2s2.5 2 4.2 2.7c1.7.7 4 1.5 7 2.4 4.1 1.2 7.4 2.4 10 3.6 2.6 1.2 4.8 3 6.7 5.4 1.9 2.4 2.8 5.6 2.8 9.5 0 3.4-.9 6.5-2.6 9.4-1.8 2.9-4.3 5.2-7.7 6.9-3.4 1.7-7.4 2.6-12 2.6-4.5-.1-8.4-.9-12-2.4zM873.9 146.3h-36.6c.3 3.6 1.6 6.5 3.8 8.5 2.2 2.1 5 3.1 8.2 3.1 4.7 0 8.1-2 10-6.1H873c-1.4 4.8-4.2 8.8-8.3 11.9-4.1 3.1-9.1 4.7-15.1 4.7-4.8 0-9.2-1.1-13-3.2-3.8-2.1-6.8-5.2-9-9.1-2.1-3.9-3.2-8.4-3.2-13.6 0-5.2 1.1-9.7 3.2-13.7 2.1-3.9 5.1-6.9 8.9-9 3.8-2.1 8.2-3.2 13.1-3.2 4.8 0 9 1 12.8 3.1 3.8 2.1 6.7 5 8.8 8.7 2.1 3.8 3.1 8.1 3.1 13-.1 1.8-.2 3.4-.4 4.9zm-12.8-8.5c-.1-3.3-1.2-5.9-3.5-7.8-2.3-2-5.1-2.9-8.4-2.9-3.1 0-5.8 1-7.9 2.8-2.1 1.9-3.5 4.5-3.9 7.9h23.7zM896.1 100.6v67h-12.7v-67h12.7zM954.9 146.3h-36.6c.3 3.6 1.6 6.5 3.8 8.5 2.2 2.1 5 3.1 8.2 3.1 4.7 0 8.1-2 10-6.1H954c-1.4 4.8-4.2 8.8-8.3 11.9-4.1 3.1-9.1 4.7-15.1 4.7-4.8 0-9.2-1.1-13-3.2-3.8-2.1-6.8-5.2-9-9.1-2.1-3.9-3.2-8.4-3.2-13.6 0-5.2 1.1-9.7 3.2-13.7 2.1-3.9 5.1-6.9 8.9-9 3.8-2.1 8.2-3.2 13.1-3.2 4.8 0 9 1 12.8 3.1 3.8 2.1 6.7 5 8.8 8.7 2.1 3.8 3.1 8.1 3.1 13-.1 1.8-.2 3.4-.4 4.9zm-12.8-8.5c-.1-3.3-1.2-5.9-3.5-7.8-2.3-2-5.1-2.9-8.4-2.9-3.1 0-5.8 1-7.9 2.8-2.1 1.9-3.5 4.5-3.9 7.9h23.7zM964.4 128.9c2.1-3.9 5-6.9 8.8-9 3.7-2.1 8-3.2 12.8-3.2 6.2 0 11.4 1.6 15.4 4.7 4.1 3.1 6.8 7.5 8.2 13.1h-13.7c-.7-2.2-1.9-3.9-3.7-5.1-1.7-1.2-3.8-1.9-6.4-1.9-3.6 0-6.5 1.3-8.6 3.9-2.1 2.6-3.2 6.3-3.2 11.2 0 4.8 1.1 8.5 3.2 11.1 2.1 2.6 5 3.9 8.6 3.9 5.1 0 8.5-2.3 10-6.9h13.7c-1.4 5.4-4.1 9.7-8.2 12.9-4.1 3.2-9.2 4.8-15.4 4.8-4.8 0-9.1-1.1-12.8-3.2-3.7-2.1-6.7-5.2-8.8-9s-3.2-8.4-3.2-13.6c.1-5.3 1.1-9.8 3.3-13.7zM1033.7 127.8V152c0 1.7.4 2.9 1.2 3.7.8.8 2.2 1.1 4.1 1.1h5.9v10.7h-8c-10.7 0-16-5.2-16-15.6v-24.2h-6v-10.4h6V105h12.8v12.4h11.2v10.4h-11.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWonderlicSelectLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wonderlic_select_logo.9ebf7808ba93c366e12178f9c19fcf54.svg";